import { ReactElement, useEffect } from 'react';
import { stepsChecker } from 'utils/general';

import {
  HeroNumbers,
  Inputs,
  Operations,
  WorkforceSections,
} from '@/modules/home';
import HomeApprovalsSection from '@/modules/home/components/PageContent/Approvals';
import { VerifyEmailBanner } from '@/modules/Onboarding';
import { HomeSetupGuide } from '@/modules/Onboarding/components/SetupGuide/HomeSetupGuide';
import ExpiredPopup from '@/shared/components/molecules/ExpiredPopup';
import FloatingSubscriptionCard from '@/shared/components/molecules/FloatingSubscriptionCard';
import { EntityType } from '@/shared/constant/enums';
import { roles } from '@/shared/constant/roles-and-permissions';
import { useAuth } from '@/shared/hooks/context/auth';
import { IAuthContext } from '@/shared/hooks/context/auth/IAuthContext';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
import useCheckSubscriptionStatus from '@/shared/hooks/useCheckSubscriptionStatus';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

const PageContent = (): ReactElement => {
  const showSubscriptionCTA = useCheckSubscriptionStatus();
  const { freeTrialOver } = useFreeTrial();
  const { openModal, closeModal } = useModal();
  const [selectedAsset] = useStore((store) => store?.asset);
  const [isDemoFarm] = useStore((store) => store?.isDemoFarm);
  const { user, onboardingChecks } = useAuth();
  const stepsCount = stepsChecker({
    hasFields: onboardingChecks?.hasFields,
    hasTeamMembers: onboardingChecks?.hasTeamMembers,
  });

  const hasSeenExpiredPopup = JSON.parse(
    sessionStorage.getItem('hasSeenExpiredPopup') ?? 'false'
  );

  // TODO(abdo): remove this once UserHasPermission is refactored
  const rolesWithPermission: IAuthContext.RolesType[] = [
    roles.COMPANY_ADMIN,
    roles.OWNER,
    roles.SUPER_ADMIN,
    roles.FINANCIAL_MANAGER,
  ];
  const hasPermissionToSeeExpiredPopup = rolesWithPermission.includes(
    user?.userGroupId ?? roles.OWNER
  );
  const canSeeFloatingCard =
    hasPermissionToSeeExpiredPopup &&
    hasSeenExpiredPopup &&
    freeTrialOver &&
    showSubscriptionCTA;

  useEffect(() => {
    if (
      showSubscriptionCTA &&
      hasPermissionToSeeExpiredPopup &&
      !hasSeenExpiredPopup
    ) {
      setTimeout(() => {
        openModal(<ExpiredPopup />, {
          dismissable: false,
          variant: 'popup',
          onClose: () => {
            sessionStorage.setItem('hasSeenExpiredPopup', JSON.stringify(true));
            closeModal();
            closeModal();
          },
        });
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className='col-span-6 mb-24 flex flex-col gap-32 tablet:col-span-4'>
      {!user?.isEmailVerified && user?.email && !isDemoFarm ? (
        <VerifyEmailBanner />
      ) : (
        ''
      )}
      {stepsCount < 2 &&
      selectedAsset?.entityTypeId === EntityType.FARM &&
      !isDemoFarm ? (
        <HomeSetupGuide />
      ) : (
        ''
      )}
      <HeroNumbers />
      <Operations />
      <WorkforceSections />
      <HomeApprovalsSection />
      {selectedAsset?.entityTypeId === EntityType.FARM && <Inputs />}
      {canSeeFloatingCard && <FloatingSubscriptionCard />}
    </section>
  );
};
export { PageContent };
